import { Fieldset, TextField } from '@zenterprise-inc/ui';
import { ChangeEvent } from 'react';

import { useChangePasswordContext } from '@/components/my/password/contexts/ChangePasswordProvider';
import { usePasswordError } from '@/components/my/password/hooks/use-password-error';

export const NewPasswordInput = () => {
  const { newPassword, changeNewPassword } = useChangePasswordContext();
  const { passwordError, resetPasswordError, inputPasswordError } = usePasswordError();

  const handleChangePassword = (e: ChangeEvent<HTMLInputElement>) => {
    if (passwordError !== 'NONE') {
      resetPasswordError();
    }
    changeNewPassword(e);
  };

  const isError = passwordError !== 'NONE';

  return (
    <Fieldset.Wrapper isInvalid={isError}>
      <Fieldset.Label>새로운 비밀번호</Fieldset.Label>
      <TextField.Password
        value={newPassword}
        autoComplete={'off'}
        className={'flex'}
        onChange={handleChangePassword}
        onBlur={() => inputPasswordError(newPassword)}
      />
      {passwordError === 'EMPTY' && <Fieldset.Error>비밀번호를 입력해주세요.</Fieldset.Error>}
      {passwordError === 'MIN_LENGTH' && <Fieldset.Error>6자 이상 입력해주세요.</Fieldset.Error>}
    </Fieldset.Wrapper>
  );
};

export const ConfirmPasswordInput = () => {
  const { newPassword, confirmPassword, changeConfirmPassword } = useChangePasswordContext();
  const { passwordError, resetPasswordError, inputPasswordError, invalidPasswordError } = usePasswordError();
  const isError = passwordError !== 'NONE';

  const handleChangePassword = (e: ChangeEvent<HTMLInputElement>) => {
    if (passwordError !== 'NONE') {
      resetPasswordError();
    }
    changeConfirmPassword(e);
  };

  const passwordValidateCheck = () => {
    inputPasswordError(confirmPassword);

    if (newPassword !== confirmPassword) {
      invalidPasswordError();
    }
  };

  return (
    <Fieldset.Wrapper isInvalid={isError}>
      <Fieldset.Label>비밀번호 확인</Fieldset.Label>
      <TextField.Password value={confirmPassword} autoComplete={'off'} className={'flex'} onChange={handleChangePassword} onBlur={passwordValidateCheck} />
      {passwordError === 'EMPTY' && <Fieldset.Error>비밀번호를 입력해주세요.</Fieldset.Error>}
      {passwordError === 'MIN_LENGTH' && <Fieldset.Error>6자 이상 입력해주세요.</Fieldset.Error>}
      {passwordError === 'INVALID' && <Fieldset.Error>비밀번호가 일치하지 않아요. 다시 입력해주세요.</Fieldset.Error>}

      {/* 예외: api error */}
      {passwordError === 'UNKNOWN' && <Fieldset.Error>일시적인 오류가 발생했어요. 잠시 후 다시 시도해주세요.</Fieldset.Error>}
    </Fieldset.Wrapper>
  );
};
